import React, { useMemo } from "react";
import Table from "../../../../components/Table";
import { connect } from "react-redux";
import { setAuthorize } from "../../../../actions/app-action-types";
import { Typography } from "@mui/material";
import { get } from "lodash";
import styled from "styled-components";

const ImageContainer = styled.div`
  border: 1px dashed #cacaca;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
  position: relative;
  height: 60px;
  width: 150px;
  min-height: 50px;
`;

const MachineVariants = ({ variants, showFeatures, onImageUpload }) => {
  const columns = [
    {
      Header: "Sl No.",
      accessor: "srNo",
      maxWidth: 50,
    },
    {
      Header: "Variant Name",
      accessor: "variantName",
      maxWidth: 120,
    },
    {
      Header: "Feature Count",
      accessor: "features",
      Cell: (data) => {
        const features = get(data, "value") ?? [];
        const variantId = get(data, "row.original.variantId") ?? 0;
        const variantName = get(data, "row.original.variantName") ?? "";
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                marginRight: "8px",
                marginLeft: "8px",
                cursor: "pointer",
              }}
              onClick={() => showFeatures(variantId, variantName)}
            >
              <Typography
                variant="caption"
                color={"blue"}
                style={{ textDecoration: "underline" }}
              >
                {features.length ?? 0}
              </Typography>
            </div>
          </div>
        );
      },
      maxWidth: 80,
    },
    {
      Header: "Image",
      accessor: "productImage",
      maxWidth: 120,
      Cell: (data) => {
        const variantId = get(data, "row.original.variantId") ?? 0;
        const variantName = get(data, "row.original.variantName") ?? "";
        return (
          <>
            <ImageContainer>
              <img
                src={data.value}
                style={{
                  width: "100%",
                  objectFit: "contain",
                  height: "100%",
                  backgroundColor: "#F4F4F4",
                  cursor: "zoom-in",
                }}
                alt={"img"}
                onLoad={() => {}}
                onClick={() => {}}
              />
            </ImageContainer>
            <Typography
              variant="caption"
              color={"blue"}
              style={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => onImageUpload(variantId, variantName)}
            >
              {data.value ? "Change" : "Upload"}
            </Typography>
          </>
        );
      },
    },
  ];

  const tableData = useMemo(() => {
    return (
      variants?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || []
    );
  }, [variants]);

  return (
    <Table
      stickyHeader={true}
      columns={columns}
      data={tableData}
      defaultPageSize={10}
      filterSearchTop={"34px"}
      headerZIndex={1}
    />
  );
};

const mapStateToProps = ({
  app: { visible, isUnauthorize },
  schemes: { syncObject },
}) => ({
  visible,
  syncObject,
  isUnauthorize,
});

export default connect(mapStateToProps, {
  setAuthorize,
})(MachineVariants);
